/* eslint-disable */
import jsonpath from 'jsonpath';
import uuidv4 from 'uuid/v4';

export function getDataNode(data, path) {
    var data = jsonpath.query(data, path);

    // return inner array if nested
    if (Array.isArray(data[0])) return data[0];

    return data;
}

export function parseSearchData(dataNode, path) {
    const xmlDoc = new DOMParser().parseFromString(dataNode, 'text/xml');
    let theTag = xmlDoc.getElementsByTagName('a')[0];
    let isImageTag = false;
    let dataValue = '';

    if (!theTag) {
        theTag = xmlDoc.getElementsByTagName('img')[0];
        isImageTag = true;
    }

    if (theTag) {
        const targetAttribute = path.substring(path.lastIndexOf('.') + 1);

        if (targetAttribute === 'singleLineText') {
            dataValue = isImageTag ? theTag.getAttribute('src') : theTag.textContent;

        } else if (targetAttribute === 'src') {
            dataValue = theTag.getAttribute(targetAttribute) || '';

            if (process.env.VUE_APP_ENV !== 'public') {
                dataValue = process.env.VUE_APP_CM_URL + theTag.getAttribute(targetAttribute) || '';
            }
        } else {
            dataValue = theTag.getAttribute(targetAttribute) || '';
        }
    }

    return dataValue;
}

export function parseLinkData(dataNode, path) {
    const xmlDoc = new DOMParser().parseFromString(dataNode, 'text/xml');
    let theTag = xmlDoc.getElementsByTagName('link')[0];
    let dataValue = '';

    if (theTag) {
        const targetAttribute = path.substring(path.lastIndexOf('.') + 1);

        if (targetAttribute === 'href') {
            dataValue = theTag.getAttribute('url');
        } else {
            dataValue = theTag.getAttribute(targetAttribute) || '';
        }
    }

    return dataValue;
}

export function dynamicMapComponent(data, elementCopy, valueMap) {
    elementCopy.id = uuidv4();

    valueMap.forEach((mapping) => {
        dynamicMapAtom(data, elementCopy, mapping);
    });

    return elementCopy;
}

export function dynamicMapAtom(data, component, mapping) {
    if (!data || !component || !mapping.path)  return;

    let dataValue = '';

    if (mapping.transformScript) {
        const response = getDynamicDataTransformValue(data, mapping.path, mapping.transformScript);
        dataValue = response?.value;

        if (mapping.name?.indexOf('drop-zone') > -1) {
            const path = `${ mapping.path.substring(0, mapping.path.lastIndexOf('.')) }.isLink`;
            jsonpath.value(component, path, true);
        } else if (mapping.innerCollection) {
            const mapperPath = `${ mapping.path.substring(0, mapping.path.lastIndexOf('.')) }.dynamicDataMapper`;
            const componentPath = `${ mapping.path.substring(0, mapping.path.lastIndexOf('.')) }.componentId`;

            if (mapping.innerCollection.dynamicDataMapper) {
                jsonpath.value(component, mapperPath, mapping.innerCollection.dynamicDataMapper);
            }
            jsonpath.value(component, componentPath, mapping.innerCollection.selectedPremadeComponentId);
        }
        
        if (!mapping?.path.endsWith('.map') || dataValue) {
            jsonpath.value(component, mapping.path, dataValue);
        }
    }
}

export function getDynamicDataTransformValue(data, atomPath, script) {
    var response = {
        value: '',
        error: 0
    };

    if (!data) return response;
    if (!script) return response;

    // replace $data in the script with data
    // which is the first argument passed into 
    // Function(script).call(this, args[0...x])
    script = script.replace(/\$data/g, 'arguments[0]')
        .replace(/JSONPath/g, 'arguments[1]')

    try {
        /* eslint-disable no-new-func */
        response.value = getSmartMappingForAtomPath(atomPath, Function(script).call(null, data, jsonpath));
        return response;
    } catch (e) {
        console.warn(`Unable to transform. ${e}`);
        response.error = 1;
        response.message = e.message;
        return response;
    }
}

export function getSmartMappingForAtomPath(atomPath, value) {
    if (!atomPath) return '';
    if (value == null || value == undefined) return '';
    
    if (atomPath.endsWith('Text')) {
        value = value.toString();
    }

    if (atomPath.endsWith('date\']')) {
        const parseDate = new Date(value);
        if (parseDate) {
            value = parseDate.toLocaleDateString('en-US');
        }
    }
    
    if (value.toString().startsWith('/-/media') && process.env.VUE_APP_ENV !== 'public') {
        value = process.env.VUE_APP_CM_URL + value;
    }
    
    return value;
}

export function minimizeComponent(componentTemplate, elementType) {
    if (elementType.endsWith('minimal')) {
        componentTemplate.elementType = componentTemplate.elementType.indexOf('-minimal') < 0 ? `${ componentTemplate.elementType }-minimal` : componentTemplate.elementType;
        if (componentTemplate.elements) {
            componentTemplate.elements.forEach((elem) => {
                minimizeComponent(elem, `${ elem.elementType}-minimal`);
            });
        }
    }
}
